import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getGroupName } from '../../../services/api/groupApi';
import { prettyName } from '../../../utils/stringUtils';
import { getRoleChipLabel } from '../../../utils/classroomRoleUtils';
import { Label, Paragraph } from '@netexknowledge/smart-components';

export class TopBarTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      titleTooltip: undefined
    };
  }

  static propTypes = {
    pathname: PropTypes.string,
    classroomName: PropTypes.string,
    classroomRole: PropTypes.string,
    role: PropTypes.string,
    layoutSettings: PropTypes.object,
    group: PropTypes.object
  };

  componentDidMount() {
    const { classroomName, platformName } = this.props;

    let title;
    let titleTooltip;
    if (classroomName) {
      title = prettyName(classroomName, 38);
      titleTooltip = classroomName;
    } else {
      title = platformName || 'smartED | smartClassroom';
      titleTooltip = undefined;
    }
    this.setState({ title, titleTooltip });
  }

  componentDidUpdate(prevProps) {
    const { pathname, classroomName, inGroup, group, platformName } = this.props;
    let title;
    let titleTooltip;
    if (prevProps.pathname !== pathname || prevProps.classroomName !== classroomName || prevProps.inGroup !== inGroup || prevProps.group !== group) {
      if (inGroup) {
        title = getGroupName(group);
        titleTooltip = undefined;
      } else if (classroomName) {
        title = prettyName(classroomName, 38);
        titleTooltip = classroomName;
      } else {
        title = platformName || 'smartED | smartClassroom';
        titleTooltip = undefined;
      }
      this.setState({ title, titleTooltip });
    }
  }

  render() {
    const { classroomRole, role } = this.props;
    const { title, titleTooltip } = this.state;
    const titleClassNames = ['bottom', 'p--lg', 'p--semibold'];
    if (titleTooltip) titleClassNames.push('tooltip');
    const roleChipLabel = getRoleChipLabel(role, classroomRole);

    return (
      <div className="classroom-title-top">
        <Paragraph className={titleClassNames.join(' ')} dataText={titleTooltip}>
          {title}
        </Paragraph>
        {roleChipLabel && (
          <div className="guest-tag">
            <Label text={` ${roleChipLabel}`} type={'filled'}></Label>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(TopBarTitle);

function mapStateToProps(state) {
  return {
    classroomName: state.classrooms.selectedClassroom.classroom.name,
    platformName: state.account.configuration.platformName,
    pathname: state.router.location.pathname,
    layoutSettings: state.theme.layoutSettings,
    group: state.selectedGroup.group,
    i18n: state.i18n
  };
}
